import { render, staticRenderFns } from "./DistroIcon.vue?vue&type=template&id=74e05387"
import script from "./DistroIcon.vue?vue&type=script&lang=js"
export * from "./DistroIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports